<template>
  <div class="leveledGames fCol jStart aCenter">
    <div class="fCol jStart aStart fullWidth pageHolder">
      <div class="top fullWidth fRow jStart aCenter">
        <i class="material-icons-round big">stairs</i>
        <div class="fCol jCenter aStart growFull">
          <h2 class="topHead">اضافه کردن مرحله به بازی «{{game.name}}»</h2>
          <p class="desc">اضافه کردن مرحله به بازی</p>
        </div>
        <i class="material-icons-round close"
          @click="backToGames">keyboard_arrow_left</i>
      </div>
      <div class="fullWidth fRow jBetween aCenter wrap">
        <!-- عنوان مرحله -->
        <div class="fCol jStart aStart inputHolder w20" style="margin-left: 16px">
          <span class="fRow jStart aCenter">
            <status-icon
              activeLabel="priority_high"
              deactiveLabel="done_all"
              :val="!nameErr" />
            عنوان مرحله {{name.length}} / 64</span>
          <div class="fRow jStart aCenter fullWidth inputWraper">
            <input class="transition-fast"
              placeholder="عنوان مرحله"
              v-model="name"
              type="text">
          </div>
        </div>
        <!-- عنوان مرحله -->
        <div class="fCol jStart aStart inputHolder growFull">
          <span class="fRow jStart aCenter">
            <status-icon
              activeLabel="priority_high"
              deactiveLabel="done_all"
              :val="!descErr" />
            توضیحات کوتاه مرحله {{desc.length}} / 164</span>
          <div class="fRow jStart aCenter fullWidth inputWraper">
            <input class="transition-fast"
              placeholder="توضیحات کوتاه مرحله"
              v-model="desc"
              type="text">
          </div>
        </div>
      </div>
      <div class="fullWidth fRow jBetween aStart form">
        <div class="box growFull fCol jStart aStart">
          <div class="fullWidth fCol jCenter aCenter noQuestion"
            v-if="levelQuestions.length === 0">
            هنوز سؤالی انتخاب نکرده‌اید
          </div>
          <ul class="fullWidth qlist" v-if="levelQuestions.length > 0">
            <li class="fRow jStart aCenter"
              v-for="(item, index) in levelQuestions" v-bind:key="index">
              <input type="number"
                :value="index + 1"
                :id="`qIndex${index}`"
                placeholder="شماره سؤال"
                :disabled="true">
              <div class="qQuestion growFull fCol jStart aStart">
                <div class="fullWidth fRow jStart aCenter">
                  <i class="material-icons-round hard" title="سؤال سخت"
                    v-if="item.level === 'hard'">sentiment_neutral</i>
                  <i class="material-icons-round normal" title="سؤال معمولی"
                    v-if="item.level === 'normal'">sentiment_satisfied</i>
                  <i class="material-icons-round easy" title="سؤال آسان"
                    v-if="item.level === 'easy'">sentiment_very_satisfied</i>
                  <!-- <span class="q">{{item.title}}</span> -->
                  <quill-editor ref="myTextEditor"
                    class="fullWidth qlClass"
                    v-model="item.title"
                    :disabled="true"
                    :options="qItemQuillOptions"></quill-editor>
                </div>
              </div>
              <div class="b fRow fab" @click="deleteQuestion(item.id)">
                <i class="material-icons-round">delete</i>
              </div>
            </li>
          </ul>
          <div class="actions fullWidth jStart aCenter fRow"
            style="margin-top: 8px"
            v-if="true">
            <div class="b fRow jStart aCenter"
              v-bind:class="{active: formReady}">
              <i class="material-icons-round">add</i>
              <label>ثبت مرحله‌ی جدید</label>
            </div>
            <div class="b fRow jStart aCenter mini">
              <i class="material-icons-round">delete</i>
              <label>ثبت مرحله‌ی جدید</label>
            </div>
          </div>
        </div>
        <question-bank-game
          @nq="getLevelQuestions($event)"
          from="add" />
      </div>
    </div>
  </div>
</template>

<script>
import StatusIcon from '@/components/InputStatusIcon.vue';
import QuestionBankGame from '@/components/QuestionBankGame.vue';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';

export default {
  mixins: [errorHandler, makeToast],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      game: '',
      maxQuestions: 10,
      // new form
      name: '',
      nameErr: true,
      desc: '',
      descErr: true,
      levelQuestions: [],
      levelQuestionsErr: true,
      qItemQuillOptions: {
        placeholder: 'متن گزینه را وارد کنید',
        theme: 'bubble',
        modules: {
          toolbar: [
            ['formula', 'clean'],
            ['bold', 'underline'],
            [{ color: [] }, { background: [] }],
          ],
        },
      },
    };
  },
  methods: {
    backToGames() {
      this.$router.push('/game');
      this.$store.commit('clearGameToAddLevel');
    },
    getLevelQuestions(e) {
      console.error(e);
      for (let i = 0; i < e.length; i += 1) {
        if (this.levelQuestions.length < this.maxQuestions) {
          if (this.isItemInArray(e[i].id) === -1) {
            this.levelQuestions.push(e[i]);
          }
        } else {
          this.makeToast('warn', `برای هر مرحله فقط ${this.maxQuestions} سؤال وارد کنید`, 3000);
          break;
        }
      }
      console.warn(this.levelQuestions);
    },
    isItemInArray(id) {
      let ind = -1;
      for (let i = 0; i < this.levelQuestions.length; i += 1) {
        if (this.levelQuestions[i].id === id) {
          ind = i;
        }
      }
      return ind;
    },
    deleteQuestion(id) {
      if (this.isItemInArray(id) !== -1) {
        this.levelQuestions.splice(this.isItemInArray(id), 1);
      }
    },
  },
  components: {
    StatusIcon,
    QuestionBankGame,
    quillEditor,
  },
  watch: {
    name() {
      this.name = this.name.substr(0, 64);
      this.nameErr = this.name.length < 3;
      console.log('name: ', this.nameErr);
    },
    desc() {
      this.desc = this.desc.substr(0, 164);
      this.descErr = this.desc.length < 3;
      console.log('decs: ', this.descErr);
    },
    levelQuestions() {
      this.levelQuestionsErr = this.levelQuestions.length !== this.maxQuestions;
      console.log('levelQuestions: ', this.levelQuestionsErr);
    },
  },
  computed: {
    formReady() {
      return !this.nameErr
        && !this.descErr
        && !this.levelQuestionsErr;
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.katex = katex;
      this.game = this.$store.state.gameToAddLevel;
      if (this.game.id === undefined) {
        this.$router.push('/game');
      } else {
        this.$store.commit('setLoadingOff');
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

.leveledGames {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden auto;
  padding: 64px 0;
  .pageHolder {
    max-width: 1100px;
    width: 100%;
    border-radius: 16px;
    box-shadow: 0 8px 24px -8px rgba($color: #000000, $alpha: 0.25);
    padding: 24px;
    .inputHolder {
      margin-bottom: 4px;
      span {
        font-size: 12px;
        color: rgba($color: #888888, $alpha: 1.0);
        position: relative;
        i{
          font-size: 16px;
          margin-left: 8px;
        }
      }
      .inputWraper{
        position: relative;
        label{
          text-align: right;
          font-size: 12px;
          color: #888888;
        }
        input[type='number'], input[type='password'], input[type='text'], textarea{
          outline: none;
          -webkit-user-select: auto;
          -moz-user-select: auto;
          -ms-user-select: auto;
          user-select: auto;
          border: solid 2px rgba($color: $azadSecondary, $alpha: 0.25);
          padding: 3px 12px !important;
          text-align: right !important;
          margin: 8px 0px 8px 0 !important;
          font-size: 16px;
          font-weight: 300;
          letter-spacing: 0px;
          width: 100%;
          border-radius: 8px;
          color: $azadDarkText;
          resize: none;
          background-color: rgba(0, 0, 0, 0);
        }
        input[type='number']::placeholder,
        input[type='password']::placeholder,
        input[type='text']::placeholder,
        textarea::placeholder{
          font-weight: 100;
        }
        input[type='number']:disabled, input[type='password']:disabled, input[type='text']:disabled{
          font-size: 14px;
          opacity: 0.75;
        }
        textarea {
          max-height: 340px !important;
        }
      }
    }
    .top {
      margin-bottom: 24px;
      i.big {
        font-size: 48px;
        margin-left: 8px;
      }
      i.close {
        cursor: pointer;
        padding: 8px;
        border-radius: 50%;
        background-color: rgba($color: #000000, $alpha: 0.05);
        transition: all linear 0.1s;
      }
      i.close:hover {
        box-shadow: 0 0 0 8px rgba($color: #000000, $alpha: 0.015);
      }
      h2.topHead {
        font-size: 14px;
        font-weight: bold;
        padding: 0;
        margin: 0;
      }
      p.desc {
        padding: 0;
        margin: 0px 0 0 0;
        font-size: 12px;
      }
    }
    .form {
      .box {
        margin-left: 16px;
        .noQuestion {
          padding: 96px 64px;
          border-radius: 16px;
          border: dashed 1px rgba($color: #000000, $alpha: 0.25);
        }
        ul.qlist {
          padding: 0;
          margin: 0;
          max-height: 660px;
          border-radius: 8px;
          border: solid 1px rgba($color: #000000, $alpha: 0.05);
          overflow: hidden auto;
          li {
            list-style-type: none;
            padding: 16px;
            border-bottom: 1px solid rgba($color: #000000, $alpha: 0.05);
            .qindex {
              width: 24px;
              min-width: 24px;
              font-size: 10px;
              font-weight: 300;
              text-align: right;
            }
            .qQuestion {
              span.q {
                font-size: 13px;
                font-weight: bold;
                text-align: right;
              }
              i {
                margin-left: 8px;
                opacity: 0.5;
                transition: all ease-in-out 0.3s;
              }
              i:hover {
                opacity: 1;
              }
              i.hard {
                color: rgb(206, 0, 0);
              }
              i.normal {
                color: rgb(27, 190, 49);
              }
              i.easy {
                color: rgb(54, 101, 161);
              }
              .qOptions {
                p {
                  font-size: 12px;
                  text-align: right;
                  margin-top: 8px;
                  font-weight: bold;
                }
              }
            }
            @keyframes inp {
              0% {
                box-shadow: 0 0 0 0 rgba($color: #000000, $alpha: 0.25);
              }
              100% {
                box-shadow: 0 0 0 16px rgba($color: #000000, $alpha: 0.0);
              }
            }
            input[type='number'] {
              width: 32px;
              text-align: center;
              border-radius: 8px;
              border: solid 2px rgba($color: #000000, $alpha: 0.1);
              animation: inp 2s cubic-bezier(1, 0, 0, 1) infinite;
              margin-left: 8px;
            }
            input[type='number']:disabled {
              width: 32px;
              text-align: center;
              border-radius: 8px;
              border: solid 2px rgba($color: #000000, $alpha: 0.0);
              animation: none;
              margin-left: 8px;
            }
          }
          li.selected {
            background-color: rgba($color: #000000, $alpha: 0.05);
          }
          li:hover {
            background-color: rgba($color: #000000, $alpha: 0.02);
            border-bottom: 1px solid rgba($color: #000000, $alpha: 0.0);
          }
        }
      }
    }
  }
}
</style>
